import { Component, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

/**
 * Last-resort catch so a rendering error in one page can never blank the
 * whole CMS. Offers a reload, which recovers from transient bad state.
 */
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Unexpected error in the CMS:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="page">
          <div className="error-state" role="alert">
            <h2>Something went wrong</h2>
            <p>Sorry about that — this page hit an unexpected problem. Your content is safe.</p>
            <button className="btn btn-primary" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
